import React from "react";

/**
 * Renders a bulk upload icon as an SVG component.
 *
 * @param {string} cls - The class name for styling the SVG component.
 * @return {JSX.Element} The bulk upload icon SVG component.
 */
const BulkUploadIcon = ({ cls = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cls}
    >
      <path
        d="M18.125 4.12461H12.413C12.2782 4.12461 12.1417 4.09311 12.0219 4.03274L9.263 2.65374C8.89987 2.47174 8.49388 2.37549 8.087 2.37549H5.875C3.46263 2.37461 1.5 4.33724 1.5 6.74961V17.2496C1.5 19.662 3.46263 21.6246 5.875 21.6246H8.5C8.983 21.6246 9.375 21.2335 9.375 20.7496C9.375 20.2657 8.983 19.8746 8.5 19.8746H5.875C4.42775 19.8746 3.25 18.6969 3.25 17.2496V9.37461H20.75V17.2496C20.75 18.6969 19.5723 19.8746 18.125 19.8746H15.5C15.017 19.8746 14.625 20.2657 14.625 20.7496C14.625 21.2335 15.017 21.6246 15.5 21.6246H18.125C20.5374 21.6246 22.5 19.662 22.5 17.2496V8.49961C22.5 6.08724 20.5374 4.12461 18.125 4.12461ZM3.25 6.74961C3.25 5.30236 4.42775 4.12461 5.875 4.12461H8.087C8.22175 4.12461 8.3565 4.15611 8.47813 4.21736L11.2396 5.59724C11.6027 5.77836 12.0079 5.87374 12.413 5.87374H18.125C19.2642 5.87374 20.2267 6.60786 20.589 7.62374H3.25V6.74961ZM14.0064 15.4086L12.875 14.2772V20.7496C12.875 21.2335 12.483 21.6246 12 21.6246C11.517 21.6246 11.125 21.2335 11.125 20.7496V14.2772L9.99362 15.4086C9.823 15.5792 9.599 15.665 9.375 15.665C9.151 15.665 8.927 15.5792 8.75638 15.4086C8.41425 15.0665 8.41425 14.5135 8.75638 14.1714L10.1678 12.76C11.146 11.7809 12.8531 11.7809 13.8322 12.76L15.2436 14.1714C15.5857 14.5135 15.5857 15.0665 15.2436 15.4086C14.9015 15.7507 14.3485 15.7507 14.0064 15.4086Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default BulkUploadIcon;
